import { render } from "./SteamMachinePrice.vue?vue&type=template&id=b6e8fc00&scoped=true"
import script from "./SteamMachinePrice.vue?vue&type=script&lang=js"
export * from "./SteamMachinePrice.vue?vue&type=script&lang=js"

import "./SteamMachinePrice.vue?vue&type=style&index=0&id=b6e8fc00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e8fc00"]])

export default __exports__